/* eslint-disable no-console */
import {InfoCircleOutlined} from '@ant-design/icons';
import {Form, Row, Col, Slider, FormItemProps} from 'antd';
import React from 'react';

import {CommonErrors} from '../../constants/Common';
import NumberInput from '../../shared/NumberInput';
import RegEx from '../../utils/FormUtils/RegEx';

const PercentageSlider: React.FC<
  {
    fieldKey: string;
    fieldLabel: string;
    tooltipTitle: any;
  } & FormItemProps
> = ({fieldKey, fieldLabel, tooltipTitle, ...props}) => {
  return (
    <div>
      <Form.Item label={fieldLabel}>
        <Row gutter={[16, 8]} style={{marginLeft: '0px', marginRight: '0px'}}>
          <Col span={21} style={{paddingLeft: '4px'}}>
            <Form.Item
              name={fieldKey}
              noStyle
              tooltip={{
                icon: <InfoCircleOutlined />,
                title: tooltipTitle
              }}
              labelCol={{span: 24}}
              {...props}
            >
              <Slider min={0} max={100} />
            </Form.Item>
          </Col>
          <Col span={3} style={{paddingRight: '0px'}}>
            <Form.Item
              name={fieldKey}
              noStyle
              rules={[
                {
                  pattern: RegEx.percentage,
                  message: CommonErrors.percentageError
                },
                ...(props?.rules ? props?.rules : [])
              ]}
            >
              <NumberInput min={0} max={100} />
            </Form.Item>
          </Col>
        </Row>
      </Form.Item>
    </div>
  );
};

export default PercentageSlider;
